export const LOGIN = "auth/login/";
export const LOGOUT = "auth/logout/";
export const ME = "me/";
export const USERS = "users/";
export const CLIENTS = "clients/";
export const VEHICLES = "vehicles/";
export const RATES = "rates/";
export const RATE_LIST = "rates/full/";
export const VEHICLE_LIST = "vehicles/full/";
export const CLIENT_LIST = "clients/full/";
export const TICKETS = "tickets/";
export const CLIENT_PAYMENT = "payment/";
export const CONSIGNMENTS = "payments/";
export const CHECKS = "checks/";
export const INVOICES = "invoices/";
export const DASHBOARD = "dashboard/";
export const PRODUCTS = "products/";
export const CONFISCATION_CAUSE = "confiscation_cause/";
export const CONFISCATIONS = "confiscation/";
export const INCOME = "income/";
export const DAILY = "daily/";
export const DAILY_LIST = "daily_list/";
export const VEHICLE = "vehicle/";
export const ACCOUNT = "accounts/";
export const SUBPRODUCTS_TYPE = "subproducts_type/";
export const SUBPRODUCTS = "subproducts/";
export const SUBPRODUCT = "subproduct/";
export const CONSIGNMENT = "consignment/";
export const PAYMENTS = "payments/";
export const ACCOUNT_DETAIL = "account_detail/";
